'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _LoginButton = require('./LoginButton');

var _LoginButton2 = _interopRequireDefault(_LoginButton);

var _PaymentOption = require('./PaymentOption');

var _PaymentOption2 = _interopRequireDefault(_PaymentOption);

var _Salespitch = require('./Salespitch');

var _Salespitch2 = _interopRequireDefault(_Salespitch);

var _Footnote = require('./Footnote');

var _Footnote2 = _interopRequireDefault(_Footnote);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Salesposter = function (_Component) {
    _inherits(Salesposter, _Component);

    function Salesposter(props) {
        _classCallCheck(this, Salesposter);

        var _this = _possibleConstructorReturn(this, (Salesposter.__proto__ || Object.getPrototypeOf(Salesposter)).call(this, props));

        _this.setTimer = function () {
            return setTimeout(function () {
                _this.setState({
                    paymentOptionsDisabled: false
                });
            }, 6000);
        };

        _this.disablePaymentOptions = function () {
            _this.setState({
                paymentOptionsDisabled: true
            });

            clearInterval(_this.timer);
            _this.timer = _this.setTimer();
        };

        _this.timer = undefined;
        _this.state = {
            paymentOptionsDisabled: false
        };
        return _this;
    }

    _createClass(Salesposter, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                theme = _props.theme,
                target = _props.target,
                spidLogin = _props.spidLogin,
                products = _props.products,
                visuallyHiddenHeading = _props.visuallyHiddenHeading,
                identifier = _props.identifier,
                campaignName = _props.campaignName,
                salespitch = _props.salespitch,
                salespitchContent = _props.salespitchContent;
            var paymentOptionsDisabled = this.state.paymentOptionsDisabled;


            var payments = products.map(function (product) {
                var paymentUrl = product.paymentUrl,
                    buyButtonText = product.buyButtonText,
                    currency = product.currency,
                    price = product.price,
                    priceDetail = product.priceDetail,
                    id = product.id,
                    title = product.title,
                    bannerText = product.bannerText,
                    isPromoted = product.isPromoted;

                var additionalClassName = isPromoted ? theme.promoted : '';

                return _react2.default.createElement(_PaymentOption2.default, {
                    currency: currency,
                    key: identifier + '-' + title + '-' + id,
                    target: target,
                    paymentUrl: paymentUrl,
                    buyButtonText: buyButtonText,
                    price: price,
                    priceDetail: priceDetail,
                    productId: id,
                    title: title,
                    theme: theme,
                    bannerText: bannerText,
                    additionalClassName: additionalClassName,
                    disabled: paymentOptionsDisabled,
                    onDisable: _this2.disablePaymentOptions
                });
            });

            var salespitchComponent = void 0;
            if (products.length) {
                salespitchComponent = _react2.default.createElement(
                    'div',
                    { className: theme.salespitch },
                    _react2.default.createElement(_Salespitch2.default, {
                        target: target,
                        theme: theme,
                        campaignName: campaignName,
                        salespitch: salespitch,
                        salespitchContent: salespitchContent
                    })
                );
            }

            var loginButton = void 0;
            if (spidLogin) {
                loginButton = _react2.default.createElement(_LoginButton2.default, {
                    theme: theme,
                    spidLogin: spidLogin,
                    title: 'Er du allerede abonnent?'
                });
            }

            var targetCampaign = target !== 'app' ? theme[campaignName] : null;
            return _react2.default.createElement(
                'section',
                { className: (0, _classnames2.default)(theme.salesPoster, targetCampaign) },
                _react2.default.createElement(
                    'h1',
                    { className: theme.visuallyhidden },
                    visuallyHiddenHeading
                ),
                loginButton,
                salespitchComponent,
                _react2.default.createElement(
                    'div',
                    {
                        className: (0, _classnames2.default)(theme.paymentOptions, theme.clearfix, theme[campaignName])
                    },
                    payments
                ),
                _react2.default.createElement(_Footnote2.default, { theme: theme, target: target })
            );
        }
    }]);

    return Salesposter;
}(_react.Component);

Salesposter.propTypes = {
    theme: _propTypes2.default.shape({
        salesPoster: _propTypes2.default.string
    }),
    target: _propTypes2.default.string,
    spidLogin: _propTypes2.default.func,
    products: _propTypes2.default.array.isRequired, // eslint-disable-line react/forbid-prop-types
    visuallyHiddenHeading: _propTypes2.default.string,
    identifier: _propTypes2.default.string,
    campaignName: _propTypes2.default.string,
    salespitch: _propTypes2.default.string,
    salespitchContent: _propTypes2.default.string
};
Salesposter.defaultProps = {
    theme: {},
    target: 'web',
    spidLogin: null,
    visuallyHiddenHeading: 'Abonnementsfordeler',
    identifier: '',
    campaignName: '',
    salespitch: '',
    salespitchContent: ''
};
exports.default = Salesposter;
//# sourceMappingURL=Salesposter.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/salesposter/lib/cjs/Salesposter.js
 ** module id = 740
 ** module chunks = 1
 **/